import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Autosave from '@ckeditor/ckeditor5-autosave/src/autosave';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Image from '@ckeditor/ckeditor5-image/src/imageblock';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import LinkEditing from '@ckeditor/ckeditor5-link/src/linkediting';
import LinkUI from '@ckeditor/ckeditor5-link/src/linkui';
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import BalloonToolbar from '@ckeditor/ckeditor5-ui/src/toolbar/balloon/balloontoolbar';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
import { Bold } from 'vendor/ckeditor/plugins/bold';
import { CodeBlock } from 'vendor/ckeditor/plugins/code-block';
import { Emoji } from 'vendor/ckeditor/plugins/emoji';
import { Italic } from 'vendor/ckeditor/plugins/italic';
import { List } from 'vendor/ckeditor/plugins/list';
import { Mention } from 'vendor/ckeditor/plugins/mention/mention';
import { MentionCustomization } from 'vendor/ckeditor/plugins/mention/mention-customization';
import { Strikethrough } from 'vendor/ckeditor/plugins/strikethrough';
import { ConditionalVariables } from 'vendor/ckeditor/plugins/variables/conditional-variables';
import { SimpleVariables } from 'vendor/ckeditor/plugins/variables/simple-variables';
import { VariablesUI } from 'vendor/ckeditor/plugins/variables/variables-ui';

export const formatting_plugins = [
  Autoformat,
  Autosave,
  LinkEditing,
  AutoLink,
  BlockQuote,
  Bold,
  CodeBlock,
  Emoji,
  Image,
  Italic,
  List,
  Strikethrough,
  TodoList,
];

export const base_plugins = [Essentials, Paragraph];

export const image_plugins = [
  ImageUpload,
  CloudServices,
  EasyImage,
  SimpleUploadAdapter,
];
export const toolbar_plugins = [BalloonToolbar, LinkUI];
export const mention_plugins = [Mention, MentionCustomization];
export const base_variable_plugins = [VariablesUI];
export const simple_variable_plugins = [SimpleVariables];
export const conditional_variable_plugins = [ConditionalVariables];
